import React from 'react';

export default props => {

  // todo: check permissions

  return (
    <div>Users</div>
  );
}